import { useRef } from "react";

/* eslint-disable react-hooks/refs */

export function useLogError(error: unknown, errorMsg: string) {
    const errorRef = useRef(error);

    if (errorRef.current !== error) {
        console.error(errorMsg, error);
        errorRef.current = error;
    }
}
